import Backend from 'App/Dataman-Backend';

const {
  apiPatentResearch,
  apiPatentResearchImages,
  apiPatentResearchDocument,
  apiPatentResearchDocumentComment,
  apiUrlSuffix,
} = Backend.config;

export const PATENT_RESEARCH_PATHS = {
  research: apiPatentResearch,
  images: apiPatentResearchImages,
  documents: apiPatentResearchDocument,
  documentComments: apiPatentResearchDocumentComment,
  suffix: apiUrlSuffix,
};
